import React, { useState } from 'react';
import SubTabs from './SubTabs';

function CorePrinciples() {
  const [activeSubTab, setActiveSubTab] = useState('feelThePainTab');

  const handleSubTabChange = (subTab) => {
    setActiveSubTab(subTab);
  };

  return (
    <div className="container fh5co-hero-inner">
      <div id="principles" className="tabcontent">
        <div id="core-principles" className="fh5co-features-outer">       
          <SubTabs activeSubTab={activeSubTab} onSubTabChange={handleSubTabChange} />
        </div>
      </div>
    </div>
  );
}

export default CorePrinciples;
